import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import {
  HeaderText, BodyText, Stack, Icon,
} from '../../ui';
import OffsetBorderBox from '../../ui/OffsetBorderBox';
import iconSVG from '../../../../images/icons/icon-autocheckout.svg';
import './AutoCheckoutNote.module.scss';

export default function AutoCheckoutNote({
  clientName,
  serviceName,
  localStart,
}) {
  const [firstName] = clientName.split(' ');
  const localStartMoment = moment(localStart);
  return (
    <View styleName="auto-checkout__wrapper">
      <View styleName="display-body">
        <Inline styleName="display-body-top">
          <Icon styleName="icon" size={28} uri={iconSVG} />
          <Stack>
            <BodyText weight="bold">
              {firstName} wants to pay through StyleSeat
            </BodyText>
            <BodyText styleName="service-name">
              <BodyText styleName="service-name" emphasize>
                {serviceName}{' '}
              </BodyText>
              for {localStartMoment.format('dddd, MMM\u00A0D')} at{' '}
              {localStartMoment.format('h:mm\u00A0A')}
            </BodyText>
          </Stack>
        </Inline>
        <View styleName="box-wrapper">
          <OffsetBorderBox backgroundColor="black" borderColor="blue">
            <Stack space={8}>
              <HeaderText
                color={colors.whiteWash}
                styleName="client-name"
                level="3"
              >
                {clientName}
              </HeaderText>
              <BodyText weight="bold" color={colors.whiteWash}>
                {firstName} wants to pay through StyleSeat
              </BodyText>
              <BodyText color={colors.whiteWash}>
                {firstName} prefers the convenience of paying with their card on
                file
              </BodyText>
              <BodyText color={colors.whiteWash}>
                They will be charged automatically one hour after the
                appointment ends and your money will be deposited directly to
                your bank.
              </BodyText>
            </Stack>
          </OffsetBorderBox>
        </View>
      </View>
    </View>
  );
}

AutoCheckoutNote.propTypes = {
  clientName: PropTypes.string.isRequired,
  serviceName: PropTypes.string.isRequired,
  localStart: PropTypes.string.isRequired,
};
